import { render } from "./PortfolioSidebarHeroSection.vue?vue&type=template&id=3b773bb7&scoped=true"
import script from "./PortfolioSidebarHeroSection.vue?vue&type=script&lang=js"
export * from "./PortfolioSidebarHeroSection.vue?vue&type=script&lang=js"

import "./PortfolioSidebarHeroSection.vue?vue&type=style&index=0&id=3b773bb7&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b773bb7"],['__file',"src/scripts/view/portfolio/sections/PortfolioSidebarHeroSection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b773bb7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b773bb7', __exports__)) {
    api.reload('3b773bb7', __exports__)
  }
  
  module.hot.accept("./PortfolioSidebarHeroSection.vue?vue&type=template&id=3b773bb7&scoped=true", () => {
    api.rerender('3b773bb7', render)
  })

}


export default __exports__